
import * as React from "react";
import { Toaster as Sonner, toast } from "sonner";

/** Sonner toaster themed with our tokens. Mount once per app root. */
export function Toaster(props: React.ComponentProps<typeof Sonner>) {
  return (
    <Sonner
      className="toaster group"
      toastOptions={{
        style: {
          background: "var(--bg-overlay)",
          color: "var(--fg)",
          border: "1px solid var(--border)",
          borderRadius: "var(--radius-md)",
          fontFamily: "var(--font-sans)",
          fontSize: "13px",
        },
      }}
      {...props}
    />
  );
}

export { toast };
